import React from "react";
import { Grid, CssBaseline, Stack, Box, Typography, Hidden } from "@gti-controls-v2/web-core";
import Footer from "../../components/footer";
import loginStyles from "../../common/styles/Login";
import loginImage from "../../assets/img-login.svg"
import useTranslation from "../../hooks/useTranslation";

/** Estructura de Login */
export default function LoginLayout(props) {
	const styles = loginStyles;
	const { t } = useTranslation();

	return (
		<Grid id="login" container component="main" sx={styles.root}>
			<CssBaseline />

			<Hidden mdDown implementation="js">
				<Stack direction="column" alignItems="center" justifyContent="center"  sx={styles.description}>			
					<Box sx={styles.imageContainer}>
						<Box
							component="img"
							src={loginImage}
							alt="login"
							sx={styles.image}
						/>
					</Box>
					<Typography sx={styles.titleMonitor}>
						{t("sistema.titulos.aplicacion")}
					</Typography>
				</Stack>
			</Hidden>

			{props.children}

			<Footer />
		</Grid>
	);
}
